import { Component, OnInit, ViewChild } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { IonContent, NavController, NavParams } from "@ionic/angular";
import { Navigator } from "src/app/services/routing/navigator";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { ConfigService } from "src/app/services/config/config.service";
import { EMAIL_PATTERN } from "src/app/services/customFormValidators";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {
  public isComplete: boolean = false;
  public email: AbstractControl;
  public emailForm: FormGroup;
  showForm: boolean = true;
  public responsibleGamingNumber: string;
  public resetPasswordType: string;
  public error = null;
  @ViewChild(IonContent, { static: false }) content: IonContent;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public authService: AuthenticationService,
    public navigator: Navigator,
    protected config: ConfigService
  ) { }

  ngOnInit() {
    this.responsibleGamingNumber =
      this.config.getConfig().RESPONSIBLE_GAMING_NUMBER || "1-800-522-4700";
    this.emailForm = new FormGroup({
      email: new FormControl("", [
        Validators.pattern(EMAIL_PATTERN),
        Validators.required,
        Validators.maxLength(250)
      ]),
    });
    this.email = this.emailForm.get("email");
    this.resetPasswordType = this.config.getConfig().FEATURE_PASSWD_RESET_STEP;
  }

  onBack = () => {
    this.navigator.navigateTo("LoginComponent", { forceModal: true });
  }

  callForgotPassword() {
    this.emailForm.value.clientapp = this.config.getClientApp();


    this.authService.callForgotPassword(this.emailForm.value).subscribe(
      (response: any) => {
        this.isComplete = true;
        this.showForm = false;
        if (this.resetPasswordType && this.resetPasswordType == "MFA") {
          //redirect to next step MFA with email
          return this.navigator.navigateTo("ResetPasswordMFAEmailComponent", {}, { email: this.emailForm.value });
        }
      },
      (error) => {
        this.isComplete = true;
        this.showForm = false;
        switch (error.getErrorCode()?.toUpperCase()) {
          case 'CUSTOMER_WRONG_STATUS':
            this.isComplete = false;
            error.setErrorMessage('Please contact support to reset your password.');
            this.error = error;
            this.content.scrollToTop(10);
            break;
        }

      }
    );
  }
}
